import React, { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

const BlogDraftModal = ({ show, onHide, onConfirm, isChecking = false, newOnly = false }) => {
  const [draftChoice, setDraftChoice] = useState(newOnly ? "new" : "update"); // "update" or "new"
  const [newDraftTitle, setNewDraftTitle] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (draftChoice === "new" && !newDraftTitle.trim()) {
      setError("Please enter a title for the new draft");
      return;
    }
    
    setError("");
    onConfirm(draftChoice, newDraftTitle.trim());
  };

  const handleClose = () => {
    setDraftChoice(newOnly ? "new" : "update");
    setNewDraftTitle("");
    setError("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Save Blog as Draft</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <div className="mb-3">
          <p className="text-muted mb-3">
            {newOnly 
              ? "Enter a name for your new blog draft:"
              : "Choose how you want to save this blog draft:"
            }
          </p>
        </div>
        
        <Form>
          {!newOnly && (
            <Form.Group className="mb-3">
              <Form.Check
                type="radio"
                id="update-existing-blog"
                name="draftChoice"
                label="Update existing draft"
                checked={draftChoice === "update"}
                onChange={() => setDraftChoice("update")}
                className="mb-2"
              />
              <Form.Check
                type="radio"
                id="create-new-blog"
                name="draftChoice"
                label="Create new draft"
                checked={draftChoice === "new"}
                onChange={() => setDraftChoice("new")}
                className="mb-3"
              />
            </Form.Group>
          )}
          
          {draftChoice === "new" && (
            <Form.Group className="mb-3">
              <Form.Label>Blog Draft Name <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                value={newDraftTitle}
                onChange={(e) => {
                  setNewDraftTitle(e.target.value);
                  setError(""); // Clear error when user starts typing
                }}
                placeholder="Enter blog draft name"
                required
                autoFocus
                disabled={isChecking}
              />
              {error && (
                <Alert variant="danger" className="mt-2 mb-0">
                  <small>{error}</small>
                </Alert>
              )}
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isChecking}>
          Cancel
        </Button>
        <Button 
          variant="dark" 
          onClick={handleSubmit}
          disabled={isChecking || (draftChoice === "new" && !newDraftTitle.trim())}
        >
          {isChecking ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Saving...
            </>
          ) : (
            newOnly ? "Create Draft" : (draftChoice === "update" ? "Update Draft" : "Create New Draft")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BlogDraftModal;
